import { SignIn, SignUp } from '@clerk/clerk-react';

/* Centered auth screens on the Triton cream background. Sign-up is invite-only
   in the Clerk Dashboard, so this page is reached mainly via invitation links
   (accepting an invite to a client organization). */
function AuthShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="auth-shell">
      <div className="auth-shell__brand">
        <img src="/triton-logo.png" alt="Triton" className="auth-shell__logo" />
      </div>
      {children}
    </div>
  );
}

export function SignInPage() {
  return (
    <AuthShell>
      <SignIn signUpUrl="/sign-up" forceRedirectUrl="/" />
    </AuthShell>
  );
}

export function SignUpPage() {
  return (
    <AuthShell>
      <SignUp signInUrl="/sign-in" forceRedirectUrl="/" />
    </AuthShell>
  );
}
